import { render, staticRenderFns } from "./HistoryCompaniesSearchBox.vue?vue&type=template&id=285ad49d&scoped=true"
import script from "./HistoryCompaniesSearchBox.vue?vue&type=script&lang=js"
export * from "./HistoryCompaniesSearchBox.vue?vue&type=script&lang=js"
import style0 from "./HistoryCompaniesSearchBox.vue?vue&type=style&index=0&id=285ad49d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285ad49d",
  null
  
)

export default component.exports